export {
  default,
   getServerSideProps 
  } from '../../../../../../containers/product/index';
